<div class="h36"></div>
<div class="content contentBG fixTarget">
  <div class="rela">
    <div class="w1224 padT20B40">
      <div class="mianbaoDiv">
        <div class="floatL">您所在的位置：
          <a *ngIf="fromType == '0'" [routerLink]="['/gzEcommerceSearch']" [queryParams]="{userId: userId, userName: userName}">电商商务诚信</a>
          <a *ngIf="fromType == '1'" [routerLink]="['/gzLogisticsSearchComponent']" [queryParams]="{userId: userId, userName: userName}">物流商务诚信</a>
          》企业董监高</div>
        <div class="floatR taRight"><a onclick="history.go(-1);">返回上一页</a></div>
        <div style="clear: both"></div>
      </div>
      <div class="RsearchInputBox" style="margin: 0 auto;">
        <div style="position: relative; float: left;">
          <app-search-box #searchBox [useClass]="5"></app-search-box>
        </div>
        <button class="indSearchBtn" (click)="searchValue()">查询</button>
      </div>
      <div class="push"></div>
    </div>

    <div class="Tab1">
      <div class="Tab1Con">
        <div class="nTab">
          <div class="TabTitle w1224">
            <div class="archivesBox w100p" >
              <div class="archiveMod" style="padding-left: 0;" *ngFor="let item of searchResult?.returnData; let i = index">
                <h4 class="gqlxx">{{i+1}}.&nbsp;&nbsp;{{item.job}} - {{item.name}}</h4>
                <div>
                  <h5 class="marB20">{{i+1}}.1&nbsp;&nbsp;{{item.name}} 担任法定代表人的企业信息
                    <span class="totalClass" *ngIf="item.responseBody.Result.CIACompanyLegals?.Result ">
                      （{{item.responseBody.Result.CIACompanyLegals.Result.length}}）</span>
                  </h5>
                  <div class="formBoxA w100p" >
                    <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                      <tr>
                        <th nowrap="nowrap" width="3%">序号</th>
                        <th nowrap="nowrap" width="*">企业名称</th>
                        <th nowrap="nowrap" width="15%">统一社会信用代码/注册号</th>
                        <th nowrap="nowrap" width="16%">企业类型</th>
                        <th nowrap="nowrap" width="12%">企业状态</th>
                        <th nowrap="nowrap" width="14%">注册资本</th>
                      </tr>
                      <tbody *ngIf="item.responseBody.Result.CIACompanyLegals?.Result ">
                      <tr *ngFor="let result of item.responseBody.Result.CIACompanyLegals?.Result;let i1 = index">
                        <td>{{i1+1}}</td>
                        <td *ngIf="result.Name != null">{{result.Name}}</td>
                        <td *ngIf="result.Name == null">-</td>
                        <td *ngIf="result.RegNo != null">{{result.RegNo}}</td>
                        <td *ngIf="result.RegNo == null">-</td>
                        <td *ngIf="result.EcoKind != null">{{result.EcoKind}}</td>
                        <td *ngIf="result.EcoKind == null">-</td>
                        <td *ngIf="result.Status != null">{{result.Status}}</td>
                        <td *ngIf="result.Status == null">-</td>
                        <td *ngIf="result.RegCap != null">{{result.RegCap}}</td>
                        <td *ngIf="result.RegCap == null">-</td>
                      </tr>
                      </tbody>
                      <tbody *ngIf="!item.responseBody.Result.CIACompanyLegals?.Result">
                      <tr>
                        <td colspan="6" style="text-align: center">暂无信息</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h5 class="marB20">{{i+1}}.2&nbsp;&nbsp;{{item.name}} 对外投资的企业信息
                    <span class="totalClass" *ngIf="item.responseBody.Result.CIAForeignInvestments?.Result ">
                      （{{item.responseBody.Result.CIAForeignInvestments?.Result.length}}）</span>
                  </h5>
                  <div class="formBoxA w100p" >
                    <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                      <tr>
                        <th nowrap="nowrap" width="3%">序号</th>
                        <th nowrap="nowrap" width="*">企业名称</th>
                        <th nowrap="nowrap" width="15%">统一社会信用代码/注册号</th>
                        <th nowrap="nowrap" width="16%">企业类型</th>
                        <th nowrap="nowrap" width="12%">企业状态</th>
                        <th nowrap="nowrap" width="14%">注册资本</th>
                      </tr>
                      <tbody *ngIf="item.responseBody.Result.CIAForeignInvestments?.Result ">
                      <tr *ngFor="let result of item.responseBody.Result.CIAForeignInvestments?.Result;let i2 = index">
                        <td>{{i2+1}}</td>
                        <td *ngIf="result.Name != null">{{result.Name}}</td>
                        <td *ngIf="result.Name == null">-</td>
                        <td *ngIf="result.RegNo != null">{{result.RegNo}}</td>
                        <td *ngIf="result.RegNo == null">-</td>
                        <td *ngIf="result.EcoKind != null">{{result.EcoKind}}</td>
                        <td *ngIf="result.EcoKind == null">-</td>
                        <td *ngIf="result.Status != null">{{result.Status}}</td>
                        <td *ngIf="result.Status == null">-</td>
                        <td *ngIf="result.RegCap != null">{{result.RegCap}}</td>
                        <td *ngIf="result.RegCap == null">-</td>
                      </tr>
                      </tbody>
                      <tbody *ngIf="!item.responseBody.Result.CIAForeignInvestments?.Result">
                      <tr>
                        <td colspan="6" style="text-align: center">暂无信息</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h5 class="marB20">{{i+1}}.3&nbsp;&nbsp;{{item.name}} 任职的企业信息
                    <span class="totalClass" *ngIf="item.responseBody.Result.CIAForeignOffices?.Result ">
                      （{{item.responseBody.Result.CIAForeignOffices?.Result.length}}）</span>
                  </h5>
                  <div class="formBoxA w100p" >
                    <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mar0A table2">
                      <tr>
                        <th nowrap="nowrap" width="3%">序号</th>
                        <th nowrap="nowrap" width="*">企业名称</th>
                        <th nowrap="nowrap" width="15%">统一社会信用代码/注册号</th>
                        <th nowrap="nowrap" width="16%">企业类型</th>
                        <th nowrap="nowrap" width="12%">企业状态</th>
                        <th nowrap="nowrap" width="14%">注册资本</th>
                        <th nowrap="nowrap" width="12%">职务</th>
                      </tr>
                      <tbody *ngIf="item.responseBody.Result.CIAForeignOffices?.Result ">
                      <tr *ngFor="let result of item.responseBody.Result.CIAForeignOffices?.Result;let i2 = index">
                        <td>{{i2+1}}</td>
                        <td *ngIf="result.Name != null">{{result.Name}}</td>
                        <td *ngIf="result.Name == null">-</td>
                        <td *ngIf="result.RegNo != null">{{result.RegNo}}</td>
                        <td *ngIf="result.RegNo == null">-</td>
                        <td *ngIf="result.EcoKind != null">{{result.EcoKind}}</td>
                        <td *ngIf="result.EcoKind == null">-</td>
                        <td *ngIf="result.Status != null">{{result.Status}}</td>
                        <td *ngIf="result.Status == null">-</td>
                        <td *ngIf="result.RegCap != null">{{result.RegCap}}</td>
                        <td *ngIf="result.RegCap == null">-</td>
                        <td *ngIf="result.Position != null">{{result.Position}}</td>
                        <td *ngIf="result.Position == null">-</td>
                      </tr>
                      </tbody>
                      <tbody *ngIf="!item.responseBody.Result.CIAForeignOffices?.Result">
                      <tr>
                        <td colspan="6" style="text-align: center">暂无信息</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>

              <div class="archiveMod" style="padding-left: 0;" *ngIf="searchResult == null || !searchResult?.returnData ">
                <h4 style="text-align: center;">{{searchMsg}}</h4>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="push">
      <!--请浮动勿删-->
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enterp-employees/enterp-employees.component.html